//#
// Geocoder
// Hook up a text field and submit button to query
// google for address to location geocoding
//#

class Geocoder {
  constructor($input, $submit, success) {
    this.$input = $input;
    this.$submit = $submit;
    this.geocoder = new google.maps.Geocoder();
    this.successCallback = success;
    this.setSubmitListener();
    this.geocodeSearch();
  }

  //-----------  Private  -----------#

  setSubmitListener() {
    return this.$submit.click(() => {
      this.geocodeSearch();
    });
  }

  geocodeSearch() {
    const address = this.$input.val();
    if (address) {
      this.geocoder.geocode({ address: address }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const result = results[0];
          return this.successCallback(
            result.geometry.location,
            result.formatted_address,
          );
        }
      });
    }
  }
}

//-----------  Export  -----------#
module.exports = Geocoder;
